export const NAV_LINKS = [
  { name: "Home",             path: "/" },
  { name: "Shop",             path: "/shop" },
  { name: "Custom Jewellery", path: "/custom-jewelry" },   // ← FIX: was /custom-design, route is /custom-jewelry
  { name: "About",            path: "/about" },
  { name: "Contact",          path: "/contact" },
];